<template>
    <section class="m-industry-part">
        <h2 id="m_blk1" class="u-hello nav_choose">
            {{qsName}}，
            <span>你好！</span>
        </h2>
        <div class="m-industry-des1">
            <p
                v-for="item in explain"
                :key="item.id"
                class="u-industry-des1"
            >{{item.num}}、{{item.des}}</p>
        </div>

        <!-- 奖项参报 start-->
        <div class="m-industry-choose-box3">
            <div class="m-industry-title2">
                <h2>奖项参报</h2>
            </div>
            <div class="m-industry-choose-header">
                <span class="u-industry-choose-des1">奖项名称</span>
                <span class="u-industry-choose-des5">奖项说明</span>
                <span class="u-industry-choose-des6">是否参选</span>
            </div>
            <ul class="m-industry-choose-con">
                <li class="m-industry-choose-item" v-for="item in member_arr" :key="item.key">
                    <span class="u-industry-choose-des1">{{item.name}}</span>
                    <div class="u-industry-choose-des5">
                        <div class="u-industry-choose-des5-con">
                            <p>{{item.des}}</p>
                        </div>
                    </div>
                    <div class="u-industry-choose-des6">
                        <label
                            :data-id="item.id"
                            :class="['m-item-radio',item.sub_flag==1?'choose':'']"
                            @click="chooseState($event,1)"
                        >
                            是
                            <span class="u-item-radio"></span>
                        </label>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 奖项参报 end-->
        <!-- 参报资料填写 start-->
        <div id="m_blk2" class="m-industry-box2">
            <div class="m-industry-title2">
                <h2>参报资料填写</h2>
            </div>

            <div class="m-industry-hy-form1 m-show">
                <div class="m-industry-title3">
                    <h3>APP基本情况</h3>
                </div>

                <label class="m-industry-label1">
                    <span class="u-industry-name1">
                        <span class="start">*</span>参选APP名称：
                    </span>
                    <div class="m-industry-input1">
                        <el-input placeholder="请输入内容" v-model="form.app_name" clearable></el-input>
                    </div>
                </label>

                <div class="m-chair-box clearfix">
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">
                            <span class="start">*</span>日均活跃用户规模(万)：
                        </span>
                        <div class="m-industry-input3">
                            <el-input placeholder="请输入内容" v-model="form.app_rihuo" clearable></el-input>
                        </div>
                    </label>
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">累计总下载量(万)：</span>
                        <div class="m-industry-input3">
                            <el-input placeholder="请输入内容" v-model="form.app_down" clearable></el-input>
                        </div>
                    </label>
                </div>

                <div class="m-chair-box clearfix">
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">
                            <span class="start">*</span>2020版本迭代次数：
                        </span>
                        <div class="m-industry-input3">
                            <el-input placeholder="请输入内容" v-model="form.app_iteration" clearable></el-input>
                        </div>
                    </label>
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">安卓应用市场覆盖数：</span>
                        <div class="m-industry-input3">
                            <el-input placeholder="请输入内容" v-model="form.app_android" clearable></el-input>
                        </div>
                    </label>
                </div>

                <label class="m-industry-label1">
                    <span class="u-industry-name1">港美股券商APP名称：</span>
                    <div class="m-industry-input1">
                        <el-input placeholder="请输入内容" v-model="form.app_other_name" clearable></el-input>
                    </div>
                </label>

                <div class="m-chair-box clearfix">
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">日均活跃用户规模(万)：</span>
                        <div class="m-industry-input3">
                            <el-input placeholder="请输入内容" v-model="form.app_other_rihuo" clearable></el-input>
                        </div>
                    </label>
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">累计总下载量(万)：</span>
                        <div class="m-industry-input3">
                            <el-input placeholder="请输入内容" v-model="form.app_other_down" clearable></el-input>
                        </div>
                    </label>
                </div>

                <div class="m-chair-box clearfix">
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">2020版本迭代次数：</span>
                        <div class="m-industry-input3">
                            <el-input
                                placeholder="请输入内容"
                                v-model="form.app_other_iteration"
                                clearable
                            ></el-input>
                        </div>
                    </label>
                    <label class="m-industry-label1 fl">
                        <span class="u-industry-name2">安卓应用市场覆盖数：</span>
                        <div class="m-industry-input3">
                            <el-input
                                placeholder="请输入内容"
                                v-model="form.app_other_android"
                                clearable
                            ></el-input>
                        </div>
                    </label>
                </div>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">
                        <span class="start">*</span>重点智能服务以及用户使用情况：
                    </span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.app_textarea1"
                        ></el-input>
                    </div>
                    <p class="u-industry-des2">{{illustrateDatas.illustrate1}}</p>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">近一年内APP服务升级情况：</span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.app_textarea2"
                        ></el-input>
                    </div>
                    <p class="u-industry-des2">{{illustrateDatas.illustrate2}}</p>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">数字化赋能业务案例展示：</span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.app_textarea3"
                        ></el-input>
                    </div>
                    <p class="u-industry-des2">{{illustrateDatas.illustrate3}}</p>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">
                        <span class="start">*</span>优秀运营案例以及营销活动展示：
                    </span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.app_textarea4"
                        ></el-input>
                    </div>
                    <p class="u-industry-des2">{{illustrateDatas.illustrate4}}</p>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">
                        <span class="start">*</span>重点智能服务以及用户使用情况：
                    </span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.app_textarea5"
                        ></el-input>
                    </div>
                    <p class="u-industry-des2">{{illustrateDatas.illustrate5}}</p>
                </label>
            </div>

            <div id="m_blk3" class="m-industry-title2">
                <h2>功能服务宣传&定向评测</h2>
            </div>

            <div class="m-industry-hy-form1 m-show">
                <p class="u-industry-des5">{{illustrateDatas.illustrate6}}</p>

                <label class="m-industry-label1">
                    <span class="u-industry-name4">定向评测服务名称：</span>
                    <div class="m-industry-input1">
                        <el-input placeholder="请输入内容" v-model="form.test_name" clearable></el-input>
                    </div>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name4">基本服务介绍：</span>
                    <div class="m-industry-input1">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.test_intro"
                        ></el-input>
                    </div>
                </label>

                <label class="m-industry-label1">
                    <div class="m-chair-box clearfix">
                        <span class="u-industry-name4">重点服务推广需求名称：</span>
                        <div class="m-industry-input1">
                            <el-input placeholder="请输入内容" v-model="form.test_name2" clearable></el-input>
                        </div>
                    </div>
                    <p class="u-industry-des2">{{illustrateDatas.illustrate7}}</p>
                </label>
            </div>

            <div class="m-industry-title2">
                <h2>行业评选</h2>
            </div>

            <div class="m-industry-hy-form1 m-show">
                <label class="m-industry-label1">
                    <span class="u-industry-name3">
                        <span class="start">*</span>您认为行业最佳券商APP（请列举5家或5家以上）：
                    </span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.vote_textarea1"
                        ></el-input>
                    </div>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">
                        <span class="start">*</span>您认为行业最具成长性券商APP（请列举5家或5家以上）：
                    </span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.vote_textarea2"
                        ></el-input>
                    </div>
                </label>

                <label class="m-industry-label1">
                    <span class="u-industry-name3">您认为哪家APP特色功能服务突出（请列举3家券商以及特色服务名称）：</span>
                    <div class="m-industry-input2">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="form.vote_textarea3"
                        ></el-input>
                    </div>
                </label>
            </div>
        </div>

        <!-- 参报资料填写 end-->
        <div class="m-industry-box3">
            <a class="u-industry-btn2 fl" href="javascript:;" @click="postApply">提交</a>
            <a
                :class="['u-industry-btn2','fr',!isPrint ? 'unclick' : '']"
                href="javascript:;"
                @click="jumpAbout"
            >预览</a>
        </div>
    </section>
</template>

<script>
import Form1 from "@/components/Form1";
import Form2 from "@/components/Form2";

export default {
    name: "industry",
    components: {
        Form1,
        Form2
    },
    data() {
        return {
            // chair_time: "2010-09-10",
            explain: pageDatas.industryDatas.explain,
            tagsArr: {},
            tagsAdminArr: {},
            active: 0,
            active2: 1,
            qsName: sessionStorage.getItem("name"),
            industry: "",
            industryDesc: "",
            chair_arr: [
                {
                    name: "",
                    tele: 0,
                    time: 1
                }
            ],
            form: {
                app_name: "",
                app_rihuo: "",
                app_down: "",
                app_iteration: "",
                app_android: "",
                app_other_name: "",
                app_other_rihuo: "",
                app_other_down: "",
                app_other_iteration: "",
                app_other_android: "",
                app_textarea1: "",
                app_textarea2: "",
                app_textarea3: "",
                app_textarea4: "",
                app_textarea5: "",
                test_name: "",
                test_intro: "",
                test_name2: "",
                vote_textarea1: "",
                vote_textarea2: "",
                vote_textarea3: ""
            },
            isPrint: 0,
            member_arr: pageDatas.prizeTypeDatas,
            resultArr: [],
            illustrateDatas: pageDatas.illustrateDatas
        };
    },
    created() {
        this.getLists();
    },
    methods: {
        getLists(index, ele) {
            var _this = this;
            // http://support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.getVoteInfo?acode=zzzz_u&atype=qs
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.getVoteInfo",
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs"
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data.status;
                        if (datas) {
                            let adapterDatas = _this.adapter(datas.data);
                            _this.form = adapterDatas.list;
                            _this.isPrint = 1;
                        } else {
                            _this.isPrint = 0;
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        adapter(data) {
            var arr = data.participating_awards.split(",");
            for (var i = 0; i < this.member_arr.length; i++) {
                for (var j = 0; j < arr.length; j++) {
                    if (arr[i] == this.member_arr[i].id) {
                        this.member_arr[i].sub_flag = 1;
                    }
                }
            }
            if (!data.length) {
                return {
                    list: {
                        app_name: data.app_name,
                        app_rihuo: data.daily_activity_user,
                        app_down: data.downloads,
                        app_iteration: data.iterations_num,
                        app_android: data.android_market_num,
                        app_other_name: data.app_name_hk,
                        app_other_rihuo: data.daily_activity_user_hk,
                        app_other_down: data.downloads_hk,
                        app_other_iteration: data.iterations_num_hk,
                        app_other_android: data.android_market_num_hk,
                        app_textarea1: data.key_services_user_usage,
                        app_textarea2: data.upgrade_situation,
                        app_textarea3: data.pay_situation,
                        app_textarea4: data.digital,
                        app_textarea5: data.excellent_cases,
                        test_name: data.directional_service_name,
                        test_intro: data.directional_service_brief,
                        test_name2: data.directional_service_promotion_name,
                        vote_textarea1: data.best_broker_app,
                        vote_textarea2: data.best_growing_broker_app,
                        vote_textarea3: data.special_broker_app
                    }
                };
            }
        },
        postApply() {
            var _this = this;
            // 发送 POST 请求

            let url = "//support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.saveQSRegistInfo";
            let param = new URLSearchParams();
            // console.log(this.resultArr);
            var awardsStr = this.resultArr.join(",");

            param.append("acode", sessionStorage.getItem("acode"));
            param.append("atype", "qs");

            param.append("participating_awards", awardsStr); //奖项申报

            param.append("app_name", this.form.app_name); //参选APP名称
            param.append("daily_activity_user", this.form.app_rihuo); //日均活跃用户规模
            param.append("downloads", this.form.app_down); //累积总下载量
            param.append("iterations_num", this.form.app_iteration); //2020版本迭代次数
            param.append("android_market_num", this.form.app_android); //安卓应用市场覆盖数

            param.append("app_name_hk", this.form.app_other_name); //港美股参选APP名称
            param.append("daily_activity_user_hk", this.form.app_other_rihuo); //港美股日均活跃用户规模
            param.append("downloads_hk", this.form.app_other_down); //港美股累积总下载量
            param.append("iterations_num_hk", this.form.app_other_iteration); //港美股2020版本迭代次数
            param.append("android_market_num_hk", this.form.app_other_android); //港美股安卓应用市场覆盖数

            param.append("key_services_user_usage", this.form.app_textarea1); //重点智能服务及用户使用情况
            param.append("upgrade_situation", this.form.app_textarea2); //近一年内APP服务升级情况
            param.append("pay_situation", this.form.app_textarea3); //增值付费服务及用户使用情况
            param.append("digital", this.form.app_textarea4); //数字化赋能业务案例展示
            param.append("excellent_cases", this.form.app_textarea5); //优秀运营案例以及营销活动展示
            param.append("directional_service_name", this.form.test_name); //定向测评服务名称
            param.append("directional_service_brief", this.form.test_intro); //基本服务介绍
            param.append(
                "directional_service_promotion_name",
                this.form.test_name2
            ); //重点服务推广需求名称
            param.append("best_broker_app", this.form.vote_textarea1); //最佳券商APP
            param.append("best_growing_broker_app", this.form.vote_textarea2); //最具成长性券商APP
            param.append("special_broker_app", this.form.vote_textarea3); //最具app特色功能服务突出
            param.append("year", 2020); //最具app特色功能服务突出

            this.axios({
                method: "POST",
                url: url,
                data: param
            })
                .then(function(response) {
                    // console.log(response);
                    let data = response.data.result;
                    if (data.status.code == 0) {
                        // let msg = data.status.msg;
                        //  console.log(msg);
                        _this.$message({
                            message:
                                "恭喜你报名成功！请点击预览浏览填写内容！谢谢！",
                            type: "success"
                        });
                        _this.getLists();
                    } else {
                        let msg = data.status.msg;
                        _this.$message({
                            message: msg,
                            type: "warning"
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        jumpAbout() {
            if (!this.isPrint) {
                return;
            }
            // this.$confirm(
            //     "请提交当前填写内容后预览！",
            //     "提示",
            //     {
            //         distinguishCancelAndClose: true,
            //         confirmButtonText: "确定",
            //         cancelButtonText: "取消",
            //         type: "warning"
            //     }
            // )
            //     .then(() => {
                    this.$router.push({ path: "about" });
                // })
                // .catch(() => {
                    // this.$message({
                    //     type: "info",
                    //     message: "已取消删除"
                    // });
                // });
        },
        // addChair() {
        //     this.chair_arr.push({
        //         name: "",
        //         time: ""
        //     });
        // },
        // removeChair(item) {
        //     var index = this.chair_arr.indexOf(item);
        //     if (index !== -1) {
        //         this.chair_arr.splice(index, 1);
        //     }
        // },
        chooseState(e, type) {
            let ele = e.currentTarget;
            let id = ele.dataset.id;
            let arr = this.resultArr;
            let memArr = this.member_arr;
            // console.log(this.isRepeat(arr));
            // console.log(arr.length, memArr.length);

            if (ele.classList.contains("choose")) {
                e.currentTarget.classList.remove("choose");
                this.removeArr(arr, id);
            } else {
                // if (!this.isRepeat(arr) && arr.length < memArr.length / 2) {
                e.currentTarget.classList.add("choose");
                arr.push(id);
                // } else {
                //     this.$message({
                //         message:
                //             "投票名额已经选满，若有修改请重新选择投票对象！",
                //         type: "warning"
                //     });
                // }
            }
            // console.log(arr);
        },
        isRepeat(arr) {
            var hash = {};
            for (var i in arr) {
                if (arr[i] != 0 && hash[arr[i]]) {
                    return true;
                }
                hash[arr[i]] = true;
            }
            return false;
        },
        removeArr(arr, val) {
            var index = arr.indexOf(val);
            if (index > -1) {
                arr.splice(index, 1);
            }
        }
    }
};
</script>
